// extracted by mini-css-extract-plugin
export default {"select":"ShippingSelect_select__qh5XS"};